// --- smooth scroll --------------

// lenis smooth scroll
const lenis = new Lenis({
  smoothWheel: true, // Smooth wheel behavior
  smoothTouch: false, // Disable smooth touch scrolling (if needed)
  normalizeWheel: true, // Normalize wheel events
  // Ignore elements with the class 'scroll-section' (or any other class you use)
  ignore: (el) => el.classList.contains("scroll-section"),
});

lenis.on("scroll", ScrollTrigger.update);
gsap.ticker.add((time) => {
  lenis.raf(time * 700);
});

gsap.ticker.lagSmoothing(0);

// --- smooth scroll --------------


// search
const searchToggle = document.getElementById('searchToggle');
const searchIcon = searchToggle.querySelector('.search-icon');
const searchContainer = document.querySelector('.search_container');
const closeMob = document.querySelector('.close-mob');
const mobileFacetsLabel = document.querySelector('.mobile-facets__open-label');

searchToggle.addEventListener('click', function () {
  searchContainer.classList.toggle('active');

  // Mobile view only
  if (window.innerWidth <= 950 && mobileFacetsLabel) {
    mobileFacetsLabel.style.zIndex =
      searchContainer.classList.contains('active') ? '1' : '';
  }

  // SVG/close change only on desktop
  if (window.innerWidth > 950) {
    searchIcon.classList.toggle('active');
  }
});

// Mobile close button
if (closeMob) {
  closeMob.addEventListener('click', function () {
    searchContainer.classList.remove('active');

    // Reset z-index on mobile
    if (window.innerWidth <= 950 && mobileFacetsLabel) {
      mobileFacetsLabel.style.zIndex = '';
    }

    // Reset icon only on desktop
    if (window.innerWidth > 950) {
      searchIcon.classList.remove('active');
    }
  });
}

// search

const header = document.querySelector('header');

if (window.matchMedia('(max-width: 950px)').matches) {
  let lastScrollTop = 0;

  window.addEventListener('scroll', () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > lastScrollTop) {
      // Scroll Down
      header.classList.add('scroll-down');
      header.classList.remove('scroll-up');
    } else if (scrollTop < lastScrollTop) {
      // Scroll Up
      header.classList.add('scroll-up');
      header.classList.remove('scroll-down');
    }

    lastScrollTop = Math.max(scrollTop, 0);
  });
}


//{% comment %} =============== Low Power mode code ============ {% endcomment %}

  document.addEventListener('DOMContentLoaded', () => {
    const videos = document.querySelectorAll('video');

    if (!videos.length) return;

    const tryPlay = (video) => {
      if (video.paused) {
        const p = video.play();
        if (p !== undefined) {
          p.catch(() => {});
        }
      }
    };

    // Initial attempt
    videos.forEach((v) => tryPlay(v));

    // iOS-approved user interaction fallback
    const interactionEvents = ['touchstart', 'click', 'pointerdown'];

    const onUserInteraction = () => {
      videos.forEach((v) => tryPlay(v));
      interactionEvents.forEach((evt) => document.removeEventListener(evt, onUserInteraction));
    };

    interactionEvents.forEach((evt) => document.addEventListener(evt, onUserInteraction, { once: true }));

    // Resume if Safari pauses it (common in Low Power Mode)
    videos.forEach((video) => {
      video.addEventListener('pause', () => {
        setTimeout(() => tryPlay(video), 500);
      });
    });
  });

//{% comment %} =============== Low Power mode code ============ {% endcomment %}